/*! Wi-vars - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

var language, language_id;

var localID, pmObject;
var urls = {
    site: '',
    activity: '',
    current: '',
    dashboard: '',
    project_manager: '',
    modals: '',
    media: '',
    chat: '',
    comments: '',
    notes: '',
    tasks: '',
    seo: '',
    notifications: '',
    timeline: '',
    invoices: '',
    user: '',
    users: ''
};

var category_id, referral_category_id, referral_id, referral_type, subreferral_id, subreferral_type, target_id, target_type, chat_referral_id, chat_referral_type, chat_subreferral_id, chat_subreferral_type, comment_referral_id, comment_referral_type, comment_subreferral_id, comment_subreferral_type, media_referral_id, media_referral_type, media_subreferral_id, media_subreferral_type, media_type, media_view, media_manager_input, csrf_value;

var id, checkboxes_id = '';
var ajaxloaded = false;

+function ($) {
    'use strict';

    var wiVars = window.wiVars;
    window.wiVars = {
        init: function () {
            category_id = $('input[name="category_id"]').val();
            referral_category_id = $('input[name="referral_category_id"]').val();
            referral_id = $('input[name="referral_id"]').val();
            referral_type = $('input[name="referral_type"]').val();
            subreferral_id = $('input[name="subreferral_id"]').val();
            subreferral_type = $('input[name="subreferral_type"]').val();
            target_id = $('input[name="target_id"]').val();
            target_type = $('input[name="target_type"]').val();
            chat_referral_id = $('input[name="chat_referral_id"]').val();
            chat_referral_type = $('input[name="chat_referral_type"]').val();
            chat_subreferral_id = $('input[name="chat_subreferral_id"]').val();
            chat_subreferral_type = $('input[name="chat_subreferral_type"]').val();
            media_referral_id = $('input[name="media_referral_id"]').val();
            media_referral_type = $('input[name="media_referral_type"]').val();
            media_subreferral_id = $('input[name="media_subreferral_id"]').val();
            media_subreferral_type = $('input[name="media_subreferral_type"]').val();
            comment_referral_id = $('input[name="comment_referral_id"]').val();
            comment_referral_type = $('input[name="comment_referral_type"]').val();
            comment_subreferral_id = $('input[name="comment_subreferral_id"]').val();
            comment_subreferral_type = $('input[name="comment_subreferral_type"]').val();

            media_type = $('input[name="media_type"]').val();
            media_view = $('input[name="media_view"]').val();
            media_manager_input = $('input[name="media_manager"]').val();

            csrf_value = $('[name="wi:csrf"]').attr('content');

            wiVars.set.url();
            wiVars.set.variables();
            /*
             setInterval(function () {
             wiVars.get.csrf();
             }, 10000);
             */
        },
        set: {
            media: {
                from: {
                    object: function (obj) {
                        media_referral_id = obj.attr('data-referral-id');
                        media_referral_type = obj.attr('data-referral-type');
                        media_subreferral_id = obj.attr('data-subreferral-id');
                        media_subreferral_type = obj.attr('data-subreferral-type');

                        wiVars.set.variable('media_referral_id', media_referral_id);
                        wiVars.set.variable('media_referral_type', media_referral_type);
                        wiVars.set.variable('media_subreferral_id', media_subreferral_id);
                        wiVars.set.variable('media_subreferral_type', media_subreferral_type);
                    },
                    response: function (obj) {
                        media_referral_id = obj.referral_id;
                        media_referral_type = obj.referral_type;
                        media_subreferral_id = obj.subreferral_id;
                        media_subreferral_type = obj.subreferral_type;

                        wiVars.set.variable('media_referral_id', referral_id);
                        wiVars.set.variable('media_referral_type', referral_type);
                        wiVars.set.variable('media_subreferral_id', subreferral_id);
                        wiVars.set.variable('media_subreferral_type', subreferral_type);
                    }
                }
            },
            from: {
                object: function (obj) {
                    referral_id = obj.attr('data-referral-id');
                    referral_type = obj.attr('data-referral-type');
                    subreferral_id = obj.attr('data-subreferral-id');
                    subreferral_type = obj.attr('data-subreferral-type');

                    wiVars.set.variable('referral_id', referral_id);
                    wiVars.set.variable('referral_type', referral_type);
                    wiVars.set.variable('subreferral_id', subreferral_id);
                    wiVars.set.variable('subreferral_type', subreferral_type);
                },
                response: function (obj) {
                    referral_id = obj.referral_id;
                    referral_type = obj.referral_type;
                    subreferral_id = obj.subreferral_id;
                    subreferral_type = obj.subreferral_type;

                    wiVars.set.variable('referral_id', referral_id);
                    wiVars.set.variable('referral_type', referral_type);
                    wiVars.set.variable('subreferral_id', subreferral_id);
                    wiVars.set.variable('subreferral_type', subreferral_type);
                }
            },
            variable: function (identificator, value) {
                var identificator = $('#' + identificator);
                if (identificator.length) {
                    identificator = identificator.val(value);
                }

            },
            variables: function () {
                language = $('html').attr('lang');
                language_id = $('html').attr('data-lang');

                if ($('#category_id').length) {
                    category_id = $('#category_id').val();
                }
                if ($('#referral_category_id').length) {
                    referral_category_id = $('#referral_category_id').val();
                }
                if ($('#referral_id').length) {
                    referral_id = $('#referral_id').val();
                }
                if ($('#referral_type').length) {
                    referral_type = $('#referral_type').val();
                }
                if ($('#subreferral_id').length) {
                    subreferral_id = $('#subreferral_id').val();
                }
                if ($('#subreferral_type').length) {
                    subreferral_type = $('#subreferral_type').val();
                }
                if ($('#target_id').length) {
                    target_id = $('#target_id').val();
                }
                if ($('#target_type').length) {
                    target_type = $('#target_type').val();
                }
                if ($('#chat_referral_id').length) {
                    chat_referral_id = $('#chat_referral_id').val();
                }
                if ($('#chat_referral_type').length) {
                    chat_referral_type = $('#chat_referral_type').val();
                }
                if ($('#chat_subreferral_id').length) {
                    chat_subreferral_id = $('#chat_subreferral_id').val();
                }
                if ($('#chat_subreferral_type').length) {
                    chat_subreferral_type = $('#chat_subreferral_type').val();
                }
                if ($('#media_referral_id').length) {
                    media_referral_id = $('#media_referral_id').val();
                }
                if ($('#media_referral_type').length) {
                    media_referral_type = $('#media_referral_type').val();
                }
                if ($('#media_subreferral_id').length) {
                    media_subreferral_id = $('#media_subreferral_id').val();
                }
                if ($('#media_subreferral_type').length) {
                    media_subreferral_type = $('#media_subreferral_type').val();
                }
                if ($('#comment_referral_id').length) {
                    comment_referral_id = $('#comment_referral_id').val();
                }
                if ($('#comment_referral_type').length) {
                    comment_referral_type = $('#comment_referral_type').val();
                }
                if ($('#comment_subreferral_id').length) {
                    comment_subreferral_id = $('#comment_subreferral_id').val();
                }
                if ($('#subreferral_type').length) {
                    comment_subreferral_type = $('#comment_subreferral_type').val();
                }
                if ($('#media_type').length) {
                    media_type = $('#media_type').val();
                }
                if ($('#media_view').length) {
                    media_view = $('#media_view').val();
                }
                if ($('#media_manager_input').length) {
                    media_manager_input = $('#media_manager_input').val();
                } else {
                    media_manager_input = 'false';
                }
            },
            url: function () {
                var base_url = $('base').attr('href');
                var urlLang = '';
                if (lang['url-lang']) {
                    urlLang = lang['url-lang'] + '/';
                }
                urls = {
                    site: base_url + urlLang,
                    current: $(location).attr('href'),
                    dashboard: base_url + 'dashboard',
                    project_manager: base_url + urlLang + lang['url-project-manager'],
                    activity: base_url + 'activity',
                    media: base_url + 'media',
                    modals: base_url + 'modals',
                    chat: base_url + 'chat',
                    comments: base_url + 'comments',
                    notes: base_url + 'notes',
                    notifications: base_url + urlLang + lang['url-notifications'],
                    tasks: base_url + 'tasks',
                    timeline: base_url + 'timeline',
                    invoices: base_url + 'invoices',
                    seo: base_url + 'dashboard/seo/get',
                    user: base_url + urlLang + lang['url-user'],
                    users: base_url + urlLang + lang['url-users']
                };
            }
        },
        get: {
            csrf: function () {
            }
        }
    };
    $(function () {
        wiVars = window.wiVars;
        wiVars.init();
    });
}(jQuery);